export default __webpack_public_path__ + "img/upload-avatar-placeholder.c78ab2df.svg";